import * as APIModels from "../../../models";
import React, { useCallback, useEffect, useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { ErrorModal, ErrorModalProps } from "../modals/ErrorModal";
import { fileService } from "../../../services/file.service";
import { Globals } from "../../../helpers/globals";
import { useLocation, useParams } from "react-router-dom";
import {
    DocumentService,
    FileService,
    QueueService,
} from "../../../services/SubmissionService";
import DropdownButton from "react-bootstrap/esm/DropdownButton";
import { Dropdown } from "react-bootstrap";
import { ContactsOutlined, ControlCameraOutlined } from "@material-ui/icons";
import ProcessButtonMenu from "./ProcessMenu";
import ProcessType, { ProcessTypeOptions } from "./ProcessType";
import qs from "qs";
import FailModal from "../../../pages/queue/components/modals/FailModal";
import HoldModal from "../../../pages/queue/components/modals/HoldModal";
import { SubmissionService } from "../../../services/SubmissionService";

function OutlineDiv(props: any) {
    const [processType, setProcessType] = useState(
        ProcessTypeOptions.filter((p) => p.name === "None")[0]
    );
    const [display, setDisplay] = useState("None");

    useEffect(() => {
        if (processType.numberof !== null && processType.numberof > 0) {
            setDisplay(processType.name + " " + processType.numberof);
        } else {
            setDisplay(processType.name);
        }
    }, [processType]);

    return (
        <div
            id={props.id}
            style={{
                marginLeft: "7.5%",
                marginRight: "7.5%",
                marginBottom: "15%",
                borderRadius: "5px",
                width: "100px",
                height: "200px",
                display: "inline-grid",
            }}
            onMouseEnter={(e) => props.onMouseEnter(e)}
        >
            <div
                id={props.id + "_overlay"}
                style={{
                    backgroundColor: processType.overlay,
                    borderRadius: "5px",
                    width: "100%",
                    height: "250px",
                    opacity: "0.5",
                    zIndex: 10,
                    fontSize: "1.5em",
                    color: props.processType.titleColor,
                }}
                onClick={(e) => {
                    props.onClick(e, setProcessType);
                }}
            >
                {display}
            </div>
            <div
                style={{
                    fontWeight: "bold",
                    position: "relative",
                    justifyContent: "center",
                    // top: "100%",
                    borderRadius: "5px",
                    transform: "translateY(-100%)",
                }}
            >
                {props.children}
            </div>
        </div>
    );
}

interface QueryParams {
    submissionId?: string;
    attorneyId?: string;
    filter?: string;
    state?: string;
}

export default function SplittingUi({
    s3loc,
    filename,
}: {
    s3loc: string;
    filename: string;
}): JSX.Element {
    // region: state 📄
    // load the document from the submission
    // const [document, setDocument] = useState<APIModels.Document | null>(null);
    const s: APIModels.Submission = new APIModels.Submission();

    const [errorMessage, setErrorMessage] = useState("");
    const [pdfUrl, setPdfUrl] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [show, setShow] = useState(false);
    const [previewPageNumber, setPreviewPageNumber] = useState(1 as number);
    const [refresh, setRefresh] = useState(false);
    const [failModalShow, setFailModalShow] = useState(false);
    const [holdModalShow, setHoldModalShow] = useState(false);
    const [processType, setProcessType] = useState(
        ProcessTypeOptions.filter((p) => p.name === "None")[0]
    );
    const [submissionId, setSubmissionId] = useState("");
    const [processTypes, setProcessTypes] = useState([...ProcessTypeOptions]);
    const [submission, setSubmission] = useState<APIModels.Submission>(s);
    const [documents, setDocuments] = useState<APIModels.Document[]>(
        [] as APIModels.Document[]
    );
    const [currentDocument, setCurrentDocument] = useState<APIModels.Document>(
        {} as APIModels.Document
    );

    const location = useLocation();
    const query = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    }) as QueryParams;
    const attorneyIdTemp = query!.attorneyId;
    const submissionIdTemp = query!.submissionId;
    const filterTemp = query!.filter;
    const stateTemp = query!.state;
    console.log(attorneyIdTemp, submissionIdTemp);

    const [preProcessHash, setPreProcessHash] = useState({
        filename: filename,
        pages: [],
    } as APIModels.SplitDocument);
    // get the filename from the url from the end of the url
    //endregion

    // region: useEffects 🧪

    useEffect(() => {
        console.log({ PreProcessHash: preProcessHash });
    }, [preProcessHash]);

    const submissionUseEffectHelper = async (
        submissionId: string,
        documentId: string
    ): Promise<string[]> => {
        return new Promise<string[]>((resolve, reject) => {
            let source = "";
            if (s3loc === "" || filename === "") {
                if (query) {
                    if (submissionIdTemp) {
                        console.log({ submissionId: submissionIdTemp });
                        setSubmissionId(submissionIdTemp);
                        QueueService.get({
                            submissionId: submissionIdTemp,
                        })
                            .then(
                                (resp) => {
                                    if (resp) {
                                        console.log(resp);
                                        if (resp.data && resp.successful) {
                                            setSubmission(resp.data);
                                            setDocuments(
                                                resp.data!.documents || []
                                            );
                                            setCurrentDocument(
                                                resp.data!.documents![0]
                                            );
                                            return [
                                                resp.data!.id!,
                                                resp.data!.documents![0],
                                            ];
                                        }
                                    }
                                },
                                (err) => {
                                    reject(err);
                                }
                            )
                            .then((doc) => {
                                submissionId = doc![0] as string;
                                const document = doc![1] as APIModels.Document;
                                documentId = document!.filename!;
                                console.log(
                                    { s: submissionId },
                                    { d: documentId }
                                );

                                resolve([submissionId, documentId, ""]);
                            })
                            .then(() => {
                                console.log("get split");
                                DocumentService.getSplit({
                                    submissionId: submissionId,
                                }).then((resp) => {
                                    if (resp.data) {
                                        resp.data.filename = filename;
                                        setPreProcessHash(resp.data);
                                    } else {
                                        console.log("No data");
                                    }
                                });
                            });
                    } else if (attorneyIdTemp) {
                        QueueService.next({
                            attorneyId: attorneyIdTemp,
                            filter: filterTemp!,
                            state: stateTemp!,
                        })
                            .then(
                                (resp) => {
                                    if (resp.data && resp.successful) {
                                        setSubmission(resp.data);
                                        console.log({
                                            submission: resp.data!.id!,
                                        });
                                        submissionId = resp.data!.id!;
                                        setDocuments(
                                            resp.data!.documents || []
                                        );
                                        setCurrentDocument(
                                            resp.data!.documents![0]
                                        );
                                        return [
                                            resp.data!.id!,
                                            resp.data!.documents![0],
                                        ];
                                    }
                                },
                                (err) => {
                                    reject(err);
                                }
                            )
                            .then((resp) => {
                                submissionId = resp![0] as string;
                                const doc = resp![1] as APIModels.Document;
                                console.log("SubmissionId: " + submissionId);
                                documentId = doc?.filename ?? "";
                                console.log("DocumentId: " + documentId);
                                resolve([submissionId, documentId, ""]);
                            })
                            .then(() => {
                                DocumentService.getSplit({
                                    submissionId: submissionId,
                                }).then((resp) => {
                                    if (resp.data) {
                                        resp.data.filename = filename;

                                        setPreProcessHash(resp.data);
                                    } else {
                                        console.log("No data");
                                    }
                                });
                            });
                    }
                }
            } else {
                submissionId = s3loc + "/splits";
                documentId = filename;
                source = "upload";
                resolve([submissionId, documentId, source]);
            }
        });
    };

    useEffect(() => {
        // check if s3loc and filename are empty
        const submissionId = "";
        const documentId = "";

        submissionUseEffectHelper(submissionId, documentId).then(
            ([submissionId, documentId, source]) => {
                FileService.get({
                    submissionId: submissionId,
                    documentId: documentId,
                    source: source,
                })
                    .then(
                        (resp: any) => {
                            return resp.json().then((json: any) => {
                                return json.url;
                            });
                        },
                        (error: Error) => setErrorMessage(error.message)
                    )
                    .then((url) => {
                        function onDocumentLoadSuccess({ numPages }: any) {
                            setPageNumber(numPages);
                        }

                        setPdfUrl(url);
                        // this is a throwaway component to load the document
                        () => {
                            <Document
                                file={url}
                                onLoadSuccess={onDocumentLoadSuccess}
                            ></Document>;
                        };
                    })
                    .then(() => {
                        //const temp = preProcessHash;
                        //for (let i = 1; i <= pageNumber; i++) {
                        //    // initialize the PreProcessHash
                        //    temp!.pages?.push({
                        //        pageNumber: i,
                        //        typeof: "None",
                        //    } as APIModels.SplitDocumentPage);
                        //}
                        //setPreProcessHash(temp);
                    });
            },
            (error: Error) => setErrorMessage(error.message)
        );
    }, [filename]);

    useEffect(() => {
        const temp = preProcessHash;
        if (!(temp.pages!.length > 0)) {
            console.log("initializing pages");
            temp.pages = [];
            for (let i = 1; i <= pageNumber; i++) {
                // initialize the PreProcessHash
                temp!.pages?.push({
                    pageNumber: i,
                    pageType: "None",
                } as APIModels.SplitDocumentPage);
            }
            setPreProcessHash(temp);
            console.log(temp);
        } else {
            console.log("pages already initialized");
            temp.pages!.forEach((page) => {
                changeOutlineOnLoad(page);
            });
        }
    }, [pageNumber]);
    // endregion

    // region: functions ⚙️

    const changeOutlineAll = () => {
        const splitPages: APIModels.SplitDocumentPage[] = [];
        for (let i = 0; i < pageNumber; i++) {
            // get the page via getElementById
            //
            const page = window.document.getElementById(
                `page_${i + 1}_overlay`
            );

            page!.style.backgroundColor = processType.overlay;

            const pageSplit: APIModels.SplitDocumentPage = {
                pageNumber: i + 1,
                pageType:
                    processType.name +
                    (processType.numberof! <= 1 || processType.numberof === null
                        ? ""
                        : " " + processType.numberof!.toString()),
            };

            (page!.innerText =
                processType.name +
                (processType.numberof! <= 1 || processType.numberof === null
                    ? ""
                    : " " + processType.numberof!.toString())),
                splitPages.push(pageSplit);
        }
        console.log(splitPages);
        setPreProcessHash((prev) => {
            return {
                pages: splitPages,
                filename: filename,
            } as APIModels.SplitDocument;
        });
    };

    const cancel = (submissionId: string) => {
        SubmissionService.cancel({ submissionId, body: {} }).then(
            (resp) => {
                window.location.href = "/queue/preprocess";
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const hold = (submissionId: string, reason: string, details: string) => {
        console.log(submissionId);
        SubmissionService.hold({
            submissionId,
            body: {
                defaultMessage: parseInt(reason),
                message: details,
            } as APIModels.ActionRequest,
        }).then(
            (resp) => {
                window.location.href = "/queue/preprocess";
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const fail = (submissionId: string, reason: string, details: string) => {
        SubmissionService.fail({
            submissionId,
            body: { defaultMessage: parseInt(reason), message: details },
        }).then(
            (resp) => {
                window.location.href = "/queue/preprocess";
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const changeOutlineOnLoad = (page: APIModels.SplitDocumentPage) => {
        const pageElementToChange = window.document.getElementById(
            `page_${page.pageNumber! + 1}_overlay`
        );
        console.log(pageElementToChange!);

        const processTypeToUse = processTypes.find(
            (processType) => processType.name === page.pageType
        );
        pageElementToChange!.style.backgroundColor = processTypeToUse!.overlay;

        pageElementToChange!.innerText = processTypeToUse!.name;

        console.log(pageElementToChange);
    };

    const changeOutline = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        console.log(preProcessHash, processType);

        // get the current target
        const target = e.currentTarget;
        console.log(target);
        const [name, idpre, _] = target.id.split("_");

        const temp = preProcessHash;

        const index = temp.pages!.findIndex((p) => p.pageNumber === +idpre);

        temp!.pages![+idpre - 1].pageType! =
            processType.name +
            (processType.numberof! <= 1 || processType.numberof === null
                ? ""
                : " " + processType.numberof!.toString());

        const overlayTarget = document.getElementById(`page_${index}_overlay`)!;
        setPreProcessHash(temp);

        overlayTarget.style.backgroundColor = processType.overlay;
        overlayTarget.innerText = processType.name;
        setProcessType(processType);
    };

    const onCloseErrorModal = () => {
        setShow(false);
        setErrorMessage("");
        setErrorModalProps({
            errorMessage: "",
            onClose: onCloseErrorModal,
        } as ErrorModalProps);
        // refresh the page
        setRefresh(true);
    };

    const [errorModalProps, setErrorModalProps] = useState({
        errorMessage: "",
        onClose: onCloseErrorModal,
    } as ErrorModalProps);

    useEffect(() => {
        if (errorMessage !== "") {
            setErrorModalProps({
                ...errorModalProps,
                errorMessage: errorMessage,
            });
            setShow(true);
        } else {
            setShow(false);
        }
    }, [errorMessage]);

    const appendProcessType = (p: ProcessType) => {
        if (p.numberof !== undefined) {
            const temp = processTypes;
            temp.push(p);
            setProcessTypes(temp);
        }
    };

    const onMouseEnterOutlineDiv = (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        const id = e.currentTarget.id;
        const pageNumber = parseInt(id.split("_")[1]);
        setPreviewPageNumber(pageNumber);
    };

    // FIXME: Adam 101802::
    //        Figure out why only one page is being added to the request each time.
    const onSave = () => {
        preProcessHash.userID = currentUser?.id;
        preProcessHash.submissionID = submission.id;
        preProcessHash.filename =
            currentDocument?.filename ?? preProcessHash.filename;
        // check how many pages are not None

        const numberOfNonePages = preProcessHash.pages?.filter(
            (p) => p.pageType === "None"
        ).length;

        if (numberOfNonePages !== 0) {
            setErrorMessage(
                "You must select a process type for each page before saving."
            );
        } else {
            console.log(preProcessHash);

            DocumentService.split({
                body: preProcessHash,
            })
                .then(
                    (res) => {
                        if (res.successful && res.data) {
                            // dont need to do anything
                        } else {
                            setErrorMessage(
                                res.errorMessage ?? "Unknown Error"
                            );
                        }
                    },
                    (error: Error) => setErrorMessage(error.message)
                )
                .then(() => {
                    history.back();
                });
        }
    };

    // endregion

    const currentUser = Globals.currentUserValue;

    const DocumentPages: JSX.Element[] = [];
    return (
        <div>
            <HoldModal
                show={holdModalShow}
                onHold={(reason: string, details: string) => {
                    setHoldModalShow(false);
                    hold(submissionId, reason, details);
                }}
                onClose={() => setHoldModalShow(false)}
            />
            <FailModal
                show={failModalShow}
                onFail={(reason: string, details: string) => {
                    setFailModalShow(false);
                    fail(submissionId, reason, details);
                }}
                onCancel={() => setFailModalShow(false)}
            />
            <div className="card">
                <div className="card-header">
                    <h3>
                        Pre-Process{" "}
                        <i
                            className="ri-speed-fill"
                            style={{ color: processType.titleColor }}
                        ></i>{" "}
                        <span style={{ color: processType.titleColor }}>
                            {processType.numberof !== 1
                                ? processType.name + " " + processType.numberof
                                : processType.name}
                        </span>
                    </h3>
                    <div
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "10px",
                        }}
                    >
                        <div id="tooltip-container">
                            <a
                                href="javascript: void(0);"
                                className="text-reset font-19 py-1 px-2 d-inline-block"
                                title="Place file in hold queue"
                                onClick={() => setHoldModalShow(true)}
                            >
                                <i
                                    className="fe-pause"
                                    data-bs-container="#tooltip-container"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Place file in hold queue"
                                    data-bs-original-title="Voice Call"
                                    aria-label="Voice Call"
                                ></i>
                            </a>
                            <a
                                href="javascript: void(0);"
                                className="text-reset font-19 py-1 px-2 d-inline-block"
                                title="Stop working on current file."
                                onClick={() => cancel(submissionId)}
                            >
                                <i
                                    className="fe-stop-circle"
                                    data-bs-container="#tooltip-container"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Stop working on current file."
                                    data-bs-original-title="Video Call"
                                    aria-label="Video Call"
                                ></i>
                            </a>
                            <a
                                href="javascript: void(0);"
                                className="text-reset font-19 py-1 px-2 d-inline-block"
                                title="Fail file back to submitting attorney."
                                onClick={() => setFailModalShow(true)}
                            >
                                <i
                                    className="fe-trash-2"
                                    data-bs-container="#tooltip-container"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Fail file back to submitting attorney."
                                    data-bs-original-title="Add Users"
                                    aria-label="Add Users"
                                ></i>
                            </a>
                        </div>
                        <button
                            className="btn btn-danger"
                            style={{
                                width: "7em",
                                borderRadius: "5em",
                            }}
                            onClick={changeOutlineAll}
                        >
                            {" "}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <i className="ri-save-3-fill"></i>
                                <span>All</span>
                            </div>
                        </button>
                        <button
                            className="btn btn-success"
                            style={{
                                width: "7em",
                                borderRadius: "5em",
                            }}
                            onClick={onSave}
                        >
                            {" "}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <i className="ri-save-3-fill"></i>
                                <span>Save</span>
                            </div>
                        </button>
                    </div>
                </div>
                {show && <ErrorModal {...errorModalProps} />}
                <ProcessButtonMenu
                    setProcessType={setProcessType}
                    options={processTypes}
                    append={appendProcessType}
                    bank={ProcessTypeOptions}
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        backgroundColor: "#CBD2D8",
                        borderRadius: "1em",
                    }}
                >
                    <div>
                        <Document
                            file={pdfUrl}
                            onLoadSuccess={({ numPages }: any) => {
                                setPageNumber(numPages);
                            }}
                        >
                            <div
                                style={{
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    height: "100vh",
                                    marginTop: "1em",
                                    marginBottom: "1em",
                                    // width: "72%",
                                    // paddingLeft: "2em",
                                    // paddingRight: "2em",
                                    paddingBottom: "1em",
                                }}
                            >
                                {Array.from(
                                    new Array(pageNumber),
                                    (el, index) => (
                                        <OutlineDiv
                                            id={`page_${index + 1}`}
                                            onClick={changeOutline}
                                            onMouseEnter={(
                                                e: React.MouseEvent<
                                                    HTMLDivElement,
                                                    MouseEvent
                                                >
                                            ) => onMouseEnterOutlineDiv(e)}
                                            processType={
                                                ProcessTypeOptions.filter(
                                                    (p) => p.name === "None"
                                                )[0]
                                            }
                                        >
                                            <div
                                                style={{
                                                    zIndex: 1,
                                                    position: "relative",
                                                }}
                                            >
                                                <Page
                                                    key={`page_${index + 1}`}
                                                    pageNumber={index + 1}
                                                    width={200}
                                                />
                                            </div>
                                        </OutlineDiv>
                                    )
                                )}
                            </div>
                        </Document>
                    </div>
                    <div
                        style={{
                            marginRight: "5em",
                            marginLeft: "5em",
                            padding: "10px",
                            minWidth: `450px`,
                        }}
                    >
                        <Document file={pdfUrl}>
                            <h3>Page {previewPageNumber} Preview </h3>
                            <Page pageNumber={previewPageNumber} width={450} />
                        </Document>
                    </div>
                </div>
            </div>
        </div>
    );
}
